import React, { Component, useEffect, useRef, useState } from 'react'

import { connect, batch, useDispatch, useSelector } from 'react-redux';
import { areaStyle, styles, WhiteButton, WhiteTextField, CssTextField } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles, TextField, IconButton, ButtonBase, Popper, Typography, Divider, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import { withRouter } from 'react-router';
import Dialog from '@material-ui/core/Dialog'
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import { ThunkDispatch } from 'redux-thunk';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { getEditAreaDialogKey, isEditAreaDialogOpen, isEditAreaZoneDialogOpen,  makeGetAreaData} from '../../selectors/dialog.selector';
import { areaActions } from '../../actions/area.actions';
import classNames from 'classnames';
import { getDownloadUrl } from '../../selectors/lookahead.selector';
import moment, { Moment } from 'moment'
import CloseIcon from '@material-ui/icons/Close';
import Canvas from 'react-canvas-polygons';
import { firebaseConnect, useFirebase, useFirebaseConnect, withFirebase } from 'react-redux-firebase';
import { getProjectId } from '../../selectors/project.selector';
import { Area } from '../../models/Area';
import { Map, ImageOverlay, TileLayer} from "react-leaflet";
import { LatLngBounds } from 'leaflet';
import { IAnnotation, IShapeData, ReactPictureAnnotation } from '../../lib/react-picture-annotation';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ChromePicker, ColorChangeHandler, TwitterPicker } from 'react-color';
import Popover from '@material-ui/core/Popover';
import chroma from 'chroma-js'
import { white } from '@material-ui/core/colors';
import { Zone } from '../../models/Zone';
import { rotateAndSkewTextRadiansAndTranslate } from 'pdf-lib';

interface Props {
    isEditAreaDialogOpen: boolean;
    closeDialogValue: () => void;
    classes: ClassNameMap,
    area: Area,
    submitValue: (name: string) => Promise<void>,
}


type State = {
    name?: string
    fileUrl?: string
}

function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
  }

const _AreaDisplay = ({fileUrl, width, height, isEditing, classes, annotationRef}: {fileUrl:string, width: number, height: number, isEditing: boolean, classes:ClassNameMap, annotationRef:RefObject<ReactPictureAnnotation>}) => {
    const dispatch = useDispatch()
    const [annotationData, setAnnotationData] = useState<Record<string, IAnnotation<IShapeData>>>({});

    const projectId = useSelector(state => {
        return getProjectId(state)
    })

    const areaId = useSelector(state => {
        return getEditAreaDialogKey(state)
    })

    useFirebaseConnect(() => {
        return [
            { path: `/zones/projects/${projectId}/areas/${areaId}/zones/`, storeAs: `PROJECT_ZONES` },

        ]
    })


    
    const zones:  Record<string, Zone> = useSelector(state => {
        return !!state.firebase.data[`PROJECT_ZONES`] ? state.firebase.data[`PROJECT_ZONES`] : {}
    })

    useEffect(() => {
        if(Object.keys(annotationData).length == 0 && Object.keys(zones).length > 0 ){
            const newAnnotations: Record<string, IAnnotation<IShapeData>> = {}
            for(const zoneId in zones) {
                const zone = zones[zoneId]
                const zoneColor = !!zone.color ? zone.color : "#000"
                newAnnotations[zoneId] = {
                    id: zoneId,
                    comment: zone.name,
                    page: zone.page,
                    mark: {
                        type: 'RECT',
                        x: zone.x,
                        y: zone.y,
                        width: zone.width,
                        height: zone.height,
                        strokeColor: zoneColor ,
                        backgroundColor: chroma(zoneColor).alpha(0.1).hex()
                    }
                }
            }

            setAnnotationData(newAnnotations)
        }
    },[zones])

    const [size, setSize] = useState({
        width: window.innerWidth * .8,
        height: window.innerHeight - 16,
      })

    const onResize = () => {
        setSize({
          width: window.innerWidth * .8,
          height: window.innerHeight - 16,
        });
      };
  
      useEffect(() => {
        window.addEventListener("resize", onResize);
        return () => {
          window.removeEventListener("resize", onResize);
        };
      }, []);

    const handleNameChange = (annotationId: string) => {
        return (e: HTMLTextAreaElement ) => {
            
            setAnnotationData((annotations: Record<string, IAnnotation<IShapeData>>) => {
                const annotation = annotations[annotationId]
                if(!!e && !!e.target){ 
                    annotation.comment = e.target.value

                }
                return {
                    ...annotations,
                    [annotation.id]: annotation
                }
            })
        }
    }



    useEffect(() => {
        if(!isEditing) {
            setSelectedIds([])
        }
    }, [isEditing])

    const prevIsEditing = usePrevious(isEditing)
    const firebase = useFirebase()


    const [isUploading, setUploading] = useState<boolean>(false)

    const [transferProgress, setTransferred] = useState<number>(0)

    useEffect(() => {
        const saveAnnotations = async () => {
            setUploading(true)
            if(!isEditing && !!prevIsEditing) {
                //save zones
                annotationRef.current
                if (annotationRef.current) {
                    
                    const maxCount = Object.values(annotationData).length + 1
                    let count = 0
                    const annotations = Object.values(annotationData)
                    for(const annotationId in annotationData) {
                        const annotation = annotationData[annotationId]
                        const storageRef = firebase.storage().ref(`/zones/projects/${projectId}/areas/${areaId}/zones/`)
                        const response = annotationRef.current.extractFromCanvas(annotation.mark.x,annotation.mark.y,annotation.mark.width,annotation.mark.height)
                        const fileRef = storageRef.child(`${annotationId}.png`)
                        

                        await fileRef.putString(response, 'data_url')
                        count += 1
                        setTransferred(count/maxCount)
                    }
    
    
                }

                dispatch(areaActions.uploadZones(Object.values(annotationData)))
                
                setTransferred(1)

            }
            setUploading(false)

        }

        saveAnnotations()

    }, [dispatch, isEditing])

    const [colorAnchorEl, setColorAnchorEl] = useState<EventTarget | null>(null);


    const [isColorChangeOpen, setOpenColorChange] = useState<string>("")

    const [selectedIds, setSelectedIds] = useState<string[]>([])



    const handleColorChange = (_annotationId) => {
        
        return (color: { hex: string | undefined; }) => {
            const annotationId = isColorChangeOpen
            const newIds = [...selectedIds]
            newIds.push(annotationId)

            setSelectedIds(newIds)
            console.log('handleColorChange', annotationId,_annotationId,  color)
            setAnnotationData((annotations: Record<string, IAnnotation<IShapeData>>) => {
                console.log('handleColorChange2', annotationId,_annotationId,  {...annotations})
                const newAnnotations = {...annotations}
                const annotation = newAnnotations[annotationId]
                annotation.mark.strokeColor = color.hex
                annotation.mark.backgroundColor = chroma(color.hex).alpha(0.1).hex()

                delete newAnnotations[annotationId]

                return {
                    ...newAnnotations,
                    [annotationId]: annotation
                }
            })
        }
    }

    const popover = {
        position: 'absolute',
        zIndex: '2',
        transform: 'translate(0, -20px)',
        transition: 'all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97)'
    }
    const cover = {
        
    }

    const colorOpen = Boolean(colorAnchorEl);
    const colorId = colorOpen ? 'simple-popper' : undefined;

    return (
        <div id="areaDiv" style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%' }}>
            <ReactPictureAnnotation
                ref={annotationRef}
                editable={isEditing}
                creatable={isEditing}
                image={fileUrl}
                onLoading={(isloading) => {console.log('onLoadingCanvas',isloading)}}
                onSelect={(ids:string[]) => {
                    if(!isEditing) {
                        return
                    }
                    setSelectedIds(ids)
                }}
                selectedIds={selectedIds}
                annotationData={Object.values(annotationData)}
                onChange={(data) => {
                    if(!isEditing) {
                        return
                    }
                    setAnnotationData(data.reduce((prev, cur) => {
                    prev[cur.id] = cur
                    return prev
                }, {} as Record<string, IAnnotation<IShapeData>>))
            }}
                width={size.width}
                height={size.height}
            />
            <div style={{ width: '20%', height: '100%', backgroundColor: '#3973BE', paddingRight: 16, paddingLeft: 16, display:'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Typography variant="h6" color="#fff" style={{color: '#fff', marginTop: 8, marginBottom: 8}}>
                    Zones
                </Typography>
                <Divider style={{width: '100%', color: '#fff', backgroundColor: '#fff'}} />
                <List>
                    {Object.values(annotationData).sort((annotationA, annotationB) => annotationA.id.localeCompare(annotationB.id)).map(annotation => {
                        const annotationColor = !!annotation.mark.strokeColor ? annotation.mark.strokeColor  : '#000'
                        return (
                            <div key={annotation.id} style={{ display: 'flex', alignItems: 'center', marginTop: 16, marginBottom: 16 }}>

                                <ButtonBase onClick={(e) => {
                                    if(!isEditing) {
                                        return
                                    }
                                    setColorAnchorEl(!!colorAnchorEl ? null : e.currentTarget); 
                                    setOpenColorChange(annotation.id)
                                }} style={{ marginRight: 8 }}>
                                    <div style={{ backgroundColor: annotationColor, borderRadius: '50%', minWidth: 20, minHeight: 20, maxWidth: 20, maxHeight: 20, borderWidth: 1, borderColor: '#fff', borderStyle: 'solid' }}></div>

                                </ButtonBase>

                                <MuiThemeProvider theme={theme =>
                                        createMuiTheme({
                                            palette: {
                                                primary: white,
                                            },
                                            overrides: {
                                                MuiInput: {
                                                    // Name of the rule
                                                    underline:{
                                                        color: '#fff',
                                                    },
                                                    input: {
                                                        color: '#fff',

                                                    }
                                                
                                                },
                                            }
                                        })
                                    }
                                >
                                    <TextField disabled={!isEditing} fullWidth={true}  onChange={handleNameChange(annotation.id)} value={annotation.comment || ''} />
                                </MuiThemeProvider>

                                <Popover  onClose={() => {
                                    setColorAnchorEl(null); 
                                    setOpenColorChange("")
                                }} anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                  }}
                                  transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }} style={{zIndex: 2000}} id={colorId} open={colorOpen && isEditing} anchorEl={colorAnchorEl}>
                                    <TwitterPicker  onChangeComplete={ handleColorChange(annotation.id) } triangle="hide"/>
                                </Popover>
                            </div>
                        )
                    })}

                </List>
            </div>
        </div>
    )
}

const AreaDisplay = withStyles(areaStyle)(_AreaDisplay);

class EditAreaZoneDialog extends Component<Props, State> {
    state = {
        name:  "",
        fileUrl: "",
        isEditing: false
    }


    async closeDialog() {
        const { closeDialogValue } = this.props
        closeDialogValue()
    }

    onConfirm = () => {
       const { submitValue, closeDialogValue } = this.props
       const { name } =this.state
    
       batch(() => {
            submitValue(name)
            closeDialogValue()
       })
    }

    async onNameChange(event: any) {
        
        const name = event.target.value

        this.setState({
            name,
            fileUrl
        });
    }


    onEnter = async() => {
        const {projectId, areaKey, area} = this.props

        const entityRoute = `/blueprints/projects/${projectId}/areas/${areaKey}`

        const storageRef= this.props.firebase.storage().ref().child(`${entityRoute}/${area.fileName}`)

        

        const downloadUrl = await this.props.firebase.storage().ref().child(`${entityRoute}/${area.fileName}`).getDownloadURL()


        this.setState({
            fileUrl: downloadUrl
        })

    }


    annotationRef = React.createRef<ReactPictureAnnotation>();


    

    render() {
        const { classes, isEditAreaDialogOpen, area } = this.props;
        const { name, fileUrl } = this.state
        const areaName = !!area ? area.name : ""
        const areaDate = !!area ? area.createdAt : 0

        const topBackground = !!this.state.isEditing ? {backgroundColor: '#3973BE', opacity: .8} : {backgroundColor: 'transparent'}

        return (
            <Dialog
                onEnter={this.onEnter}
                PaperProps={{
                    style: {
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                    },
                  }}
                fullScreen={true}
                maxWidth='sm'
                fullWidth={true}
                open={isEditAreaDialogOpen}
                onBackdropClick={this.closeDialog.bind(this)}
            >
               <div className={classNames(classes.AreaFullScreenContainer)}>
                   <div style={topBackground}  className={classNames(classes.AreaFullScreenTop)}>
                        <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between'}}>
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                    <p className={classNames(classes.AreaFullScreenTopTitle)}>
                                        {areaName}
                                    </p>
                                    <p className={classNames(classes.SixteenMarginLeft, classes.AreaFullScreenTopSubTitle)} >
                                    </p>
                                </div>
                                <p className={classNames(classes.AreaFullScreenTopSubTitle)} >
                                    {moment(areaDate).format('lll')}
                                </p>
                            </div>
                            <div>
                                {!this.state.isEditing && <WhiteButton onClick={() => {this.setState({isEditing: !this.state.isEditing})}} variant="outlined">
                                    <EditIcon />
                                    Edit
                                </WhiteButton>}
                                {this.state.isEditing && <WhiteButton onClick={() => {this.setState({isEditing: !this.state.isEditing})}} variant="outlined">
                                    Save
                                </WhiteButton>}
                                <WhiteButton onClick={async () => {
                                    if (this.annotationRef.current) {

                                        const response = this.annotationRef.current.extractFromCanvas(0,0,800,800)

                                    }

                                }} style={{marginLeft: '24px'}} variant="outlined">
                                    <PrintIcon />
                                    Print
                                </WhiteButton>
                                <IconButton onClick={this.props.closeDialogValue} style={{marginLeft: '48px', marginRight: '48px'}}>
                                    <CloseIcon style={{height: '24px', width: '24px', color: '#fff'}} />
                                </IconButton>
                            </div>
                        </div>
                   </div>
                   <div className={classNames(classes.AreaFullScreenBottom)}>
                        <AreaDisplay fileUrl={fileUrl} height={800} width={800} isEditing={this.state.isEditing} annotationRef={this.annotationRef} />
                   </div>
               </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state: any) => {
    const getAreaData = makeGetAreaData();

    const mapStateToProps = (state:any, ownProps?: any) => ({
        isEditAreaDialogOpen: isEditAreaZoneDialogOpen(state),
        area: getAreaData(state),
        areaKey: getEditAreaDialogKey(state),
        projectId: getProjectId(state),
    });
    return mapStateToProps;

};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

    return {
        closeDialogValue: () => dispatch(areaActions.closedEditAreaZoneDialog()),
        submitValue: (name: string) => dispatch(areaActions.changeArea(name))
    }
};


export default compose<React.ComponentClass>(

    withRouter,
    withFirebase,
    connect(mapStateToProps, mapDispatchToProps),

    withStyles(areaStyle, { withTheme: true }),
)(EditAreaZoneDialog)





// WEBPACK FOOTER //
// ./src/components/Dialogs/EditAreaZoneDialog.tsx